import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const classifications =
{
    namespaced: true,
    state: {
        classifications: [],
        classification: {}
    },
    mutations: {
        SET_CLASSIFICATIONS(state, data) {
            state.classifications = data
        },
        SET_CLASSIFICATION(state, data) {
            state.classification = data
        }
    },
    actions: {

        addClassification({ commit }, data) {
            return axios
                .post(baseUrl + 'GHSClassifications/addClassification', data, { withCredentials: true }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
                )
                .then(res => {
                    console.log("Classification Added:", res.data);
                    // You can commit a mutation if needed
                })
                .catch(error => console.log("Error Adding Classification:", error));
        },

        getAll({ commit }) {
            return axios
                .get(baseUrl + 'GHSClassifications', { withCredentials: true })
                .then(res => {
                    //   console.log(res.data);
                    commit('SET_CLASSIFICATIONS', res.data);
                    return res.data.data;
                })
                .catch(error => console.log(error))
        },

        deleteClassification({ commit }, id) {
            return axios
                .get(baseUrl + 'DeleteVendor?vendorId=' + id, { withCredentials: true })
                .catch(error => console.log(error))
        },
        updateClassification({ commit }, { id, data }) {
            console.log(data);
            return axios
                .post(baseUrl + 'GHSClassifications/updateClassification/' + id, data, { withCredentials: true }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(res => {
                    console.log(res)
                })
        },

        //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
        getClassification({ commit }, id) {
            return axios
                .get(baseUrl + 'GetVendor/' + id, { withCredentials: true })
                .then(res => {
                    commit('SET_VENDOR', res.data)
                })
                .catch(error => console.log(error))
        },
        // addClassification({ commit }, classificationInfo) {
        //     return axios
        //         .post(baseUrl + 'AddGHSClassification', classificationInfo)
        //         .then(res => {
        //             console.log(res.data)
        //             // commit('SET_VENDOR', res.data)
        //         })
        //         .catch(error => console.log(error))
        // }
    },
    getters: {}
}

export default classifications